import React, { Component } from 'react'
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { openNewAuthChangesModal } from '../../../store/actions/authActions'
import ReactModal from 'react-modal';
import styled from 'styled-components';
import AuthWrapper from '../../auth/forms/AuthWrapper'
import PricingModal from './PricingModal'
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

const ViewButton = styled.div`
    .btn {
        color: #fafafa;
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: ${(props) => props.themeColors.themeColor};
        margin: 2px;

        &:hover {
            color: #fafafa;
            background-color: ${(props) => props.themeColors.themeColor};
        }

        &:active {
            color: #fafafa;
            background-color: ${(props) => props.themeColors.themeColor};
        }
    }
`;

class IndividualConsumable extends Component {
    constructor(props) {
        super(props)

        this.state = {
            toggle: false,
            topupsToggle: false,
        }
    }
    // handleOpenModal = () => {
    //     console.log("hello")
    //     this.setState({
    //         toggle: true
    //     })
    // }

    // handleCloseModal = () => {
    //     this.setState({
    //         toggle: false
    //     })
    // }

    render() {
        const { productOrder, individualConsumable, isSignedIn, payment, commons, themeColors, modalStyles, storeInfo } = this.props
        const { buyProdActMessage } = payment
        if (!isSignedIn) {
            return (
                <div className="container-fluid container-form">
                    <p>You are not signed in</p>
                    <ViewButton themeColors={themeColors}>
                        <button className="btn btn-flat my-3" onClick={() => { this.setState({ toggle: true }) }}>Get started for <b>free</b></button>
                    </ViewButton>
                    <ReactModal
                        style={modalStyles}
                        isOpen={this.state.toggle}
                        onRequestClose={() => { this.setState({ toggle: false }) }}
                        contentLabel="See controls"
                        ariaHideApp={false}
                    >
                        <button className="close" onClick={() => { this.setState({ toggle: false }) }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <AuthWrapper />
                    </ReactModal>
                </div>
            )
        }

        if (productOrder && individualConsumable) {
            // console.log(productOrder, individualConsumable);
            const doesConsumableBelongsToExistingPlan = productOrder.productId === individualConsumable.belongsToPlan
            // console.log(doesConsumableBelongsToExistingPlan);
            if (!doesConsumableBelongsToExistingPlan) {
                return (
                    <div className="container-fluid container-form">
                        <p>This topup can not be applied on this subscription.</p>
                        <div className="d-flex justify-content-between">
                            <p><Link to={ROUTES.PRICING} className="mx-2" style={{ color: 'black' }}><b>Check out the plans here</b></Link></p>
                            <p style={{ color: 'black' }}>or</p>
                            <p><Link to={ROUTES.CONTACT} className="mx-2" style={{ color: 'black' }}><b>Contact us for any query.</b></Link></p>
                        </div>

                    </div>
                )
            }
            return (
                <div className="container-fluid container-form">
                    <div className="card h-100" style={{ borderTopLeftRadius: '10px', borderTopRightRadius: '10px' }}>
                        <div className="card-header" style={{}}>
                            <h5><b>{individualConsumable.itemName}</b></h5>
                        </div>
                    </div>

                    <div className="card-body" style={{ backgroundColor: "white", borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px' }}>
                        <br />
                        <h5><span>{individualConsumable.itemDescription}</span></h5>
                        <br />
                        <ViewButton themeColors={themeColors}>
                            <button className="btn btn-flat my-3" onClick={() => { this.setState({ topupsToggle: true }) }}>Increase your subscription limits for {commons.priceIn}{individualConsumable.price}</button>
                        </ViewButton>
                        <p>{buyProdActMessage}</p>
                        <ReactModal
                            style={modalStyles}
                            isOpen={this.state.topupsToggle}
                            onRequestClose={() => { this.setState({ topupsToggle: false }) }}
                            contentLabel="See controls"
                            ariaHideApp={false}
                        >
                            <button className="close" onClick={() => { this.setState({ topupsToggle: false }) }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <PricingModal priceCard={individualConsumable} isTopup={true} storeInfo={storeInfo} />
                        </ReactModal>

                    </div>
                </div >
            )
        }
        else {
            return (
                <div className="container-fluid container-form">
                    <p style={{ color: 'black' }}>Loading or not found</p>
                    <p><Link to={ROUTES.CONTACT} className="mx-2" style={{ color: 'black' }}><b>Contact us for any query</b></Link></p>
                </div>
            )
        }
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        individualConsumable: state.firestore.data.IndividualConsumable,
        isSignedIn: !state.firebase.auth.isEmpty,
        modalStyles: state.appControl.modalStyles,
        payment: state.payment,
        commons: state.commons,
        productOrder: state.firestore.data.ProductOrder,
        storeInfo: state.firestore.data.StoreInfo,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        openNewAuthChangesModal: () => dispatch(openNewAuthChangesModal()),
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect((props) => {
        // console.log(props)
        let conId = props.match.params.con_id;
        // console.log(conId);
        return [
            {
                collection: "ConStore",
                doc: conId,
                storeAs: "IndividualConsumable",
            },
            {
                collection: "Configurations",
                doc: "StoreInfo",
                storeAs: "StoreInfo",
            }
        ]
    })
)(IndividualConsumable);